import { Member, Observer, Store } from '@nextforce/api'

export function compareUsersByName(a: Observer, b: Observer) {
  return (a.firstName ?? '').localeCompare(b.firstName ?? '')
}

export function filterStores(searchTerm: string, stores: Store[] | undefined) {
  if (searchTerm.length > 0 && stores) {
    return stores.filter(store => {
      const storeTags = `Store ${store.storeNumber} ${store.name} ${store.company?.name} ${store.concept?.name}`
      return storeTags.toLowerCase().includes(searchTerm.toLowerCase())
    })
  }
  return stores
}

export function filterUsers(
  searchTerm: string,
  observers: Observer[] | undefined
) {
  if (searchTerm.length > 0 && observers) {
    return observers.filter(observer => {
      const userTags = `${observer.firstName} ${observer.lastName} ${observer.title}`
      const storeTags = observer.stores
        ?.flatMap(store => {
          return `Store ${store.storeNumber} ${store.name} ${store.company?.name} ${store.concept?.name}`
        })
        .join(' ')
      const jobTitleTags = observer.jobTitle
      let tags = userTags
      if (storeTags) {
        tags = tags.concat(' ', storeTags)
      }
      if (jobTitleTags) {
        tags = tags.concat(' ', jobTitleTags)
      }
      return tags.toLowerCase().includes(searchTerm.toLowerCase())
    })
  }
  return observers
}

export function mapObserverToMember(observer: Observer): Member {
  return {
    ...observer,
    roles: observer.role ? [observer.role] : [],
  }
}
